<template>
  <div class="recipe_feed_class">
    <div class="title_class">
      <div class="title_search_box_class">
        <div class="title_text_class">
          <span class="title_text_span_class">配方名称:</span>
          <a-input class="title_text_input_class" placeholder="请输入名称/代码" @change="inputHandle"/>
        </div>
        <div class="title_text_class">
          <span class="title_text_span_class">动物类型:</span>
          <a-cascader class="title_text_input_class" :options="options" placeholder="请选择/请选择/请选择" @change="selectOnChange" />

        </div>
      </div>
      <div class="title_btn_class">
        <a-button type="primary" @click="searchHandle" class="seatch_class">查询</a-button>
        <a-button type="default" @click="resetHandle">重置</a-button>
      </div>
    </div>
    <div class="content_class">
      <div class="content_btn_class">
          <a-button type="primary" class="add_class" @click="addHandle">+新建</a-button>
          <a-button type="default" class="edit_class" @click="editHandle">编辑</a-button>
          <a-button type="danger" ghost class="del_class" @click="delHandle">删除</a-button>
      </div>
      <div class="content_table_class">
        <a-table
          :row-selection="{selectedRowKeys, onChange: onSelectChange}"
          :columns="columns"
          :data-source="list"
          :pagination="pagination"
        >
          <div slot="option" slot-scope="text,record" class="table_edit_class">
            <a class="see_class" @click="seeHandle(record)" >查看</a>
            <a @click="reportHandle(record)">报表</a>
          </div>
        </a-table>
      </div>
    </div>
    <div class="model_class">
    
      <a-modal title="新建配方" v-model="visible" ok-text="确定" cancel-text="取消" width="60%" :footer="null">
        <NewFormulaModal :noneOrblock="noneOrblock"/>
      </a-modal>
      <a-modal title="查看配方" v-model="seeEisible" ok-text="确定" cancel-text="取消" width="80%">
        <SeeRecipes/>
      </a-modal>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '配方名称',
    dataIndex: 'one'
  },
  {
    title: '代码',
    dataIndex: 'oneNum',
  },
  {
    title: '动物类型',
    dataIndex: 'one2',
    width: 120,
  },
  {
    title: '版本',
    dataIndex: 'one3',
    width: 120,
  },
  {
    title: '工厂名称',
    dataIndex: 'one4',
    width: 120,
  },
  {
    title: '用户',
    dataIndex: 'one5',
    width: 120,
  },
  {
    title: '时间',
    dataIndex: 'one6',
    width: 120,
  },
  {
    title: '备注',
    dataIndex: 'one7',
    width: 120,
  },
  {
    title: '操作',
    dataIndex: 'option',
    width:100,
    scopedSlots: { customRender: 'option' }
  },
];

import NewFormulaModal from '../EditRecipe/SelectNutritionIndex/NewFormulaModal';
import SeeRecipes from './RecipesView/SeeRecipes';
export default {
  components: {
    NewFormulaModal,
    SeeRecipes
  },
  data(){
    return {
      noneOrblock: 'none',
      selectedRowKeys: [],
      options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
          children: [
            {
              value: 'hangzhou',
              label: 'Hangzhou',
              children: [
                {
                  value: 'xihu',
                  label: 'West Lake',
                },
              ],
            },
          ],
        },
        {
          value: 'jiangsu',
          label: 'Jiangsu',
          children: [
            {
              value: 'nanjing',
              label: 'Nanjing',
              children: [
                {
                  value: 'zhonghuamen',
                  label: 'Zhong Hua Men',
                },
              ],
            },
          ],
        },
      ],
      list: [{},{},{}],
      pagination: {
        total: 50,
        pageSize: 20,
        pageSizeOptions: ['10','20','30','40','50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onShowSizeChange(current, size){console.log(current, size)},
        onChange(page, pageSize){console.log(page, pageSize)},
      },
      
      visible: false,
      seeEisible: false,
      columns,
      
      
      addList: [{key:1},{key:2}],
      
    }
  },
  methods: {
    inputHandle(){},
    selectOnChange(){},
    searchHandle(){},
    resetHandle(){},

    addHandle(){
      this.visible = true;
    },
    editHandle(){
      this.$router.push({
        path: '/recipe/edit-recipe',
        query: {name: 1}
      })
    },
    delHandle(){
      this.$confirm({
        title: '提示',
        content: '确认将选中的配方删除吗？',
        cancelText:'取消',
        okText:'确定',
        onOk() {
          console.log('删除成功。')
        },
        onCancel() {
          console.log('取消删除。')
        },
      });
    },

    onSelectChange(){},
    seeHandle(){
      this.seeEisible = true;
    },
    reportHandle(){},
    

  }
  
}
</script>
<style lang="scss" scoped>
.recipe_feed_class {
  height: 100%;
  .title_class {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      margin-bottom: 10px;
      border-radius: 5px;
      padding: 15px;
      .title_search_box_class {
        display: flex;
        align-content: center;
        .title_text_class {
          display: flex;
          align-items: center;
          .title_text_span_class {
            margin-right: 10px;
          }
          .title_text_input_class {
            flex: 1;
          }
        }
      }
      .title_btn_class {
        .seatch_class {
          margin-right: 10px;
        }
      }
  }
  .content_class {
    background-color: #fff;
    padding: 12px 16px;
    border-radius: 5px;
    .content_btn_class {
      margin-bottom: 10px;
      .add_class {
        margin-right: 10px;
      }
      .edit_class {
        margin-right: 10px;
      }
    }
  }
  .content_table_class {
    .table_edit_class {
      .see_class {
        margin-right: 10px;
      }
    }
  }
}
  
</style>